export const InteractionState = {
  Pinned: "pinned",
  Hover: "hover",
  Default: "default",
} as const;

export type InteractionStateKey = (typeof InteractionState)[keyof typeof InteractionState];
